import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/paging_arrow_left.png'
import _imports_1 from '@/assets/images/paging_arrow_right.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_contents" }
const _hoisted_3 = { class: "top_menu" }
const _hoisted_4 = { class: "contents_div" }
const _hoisted_5 = { class: "page_header" }
const _hoisted_6 = { class: "page_header" }
const _hoisted_7 = { class: "styled-table" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "align_left" }
const _hoisted_10 = { class: "align_left" }
const _hoisted_11 = { class: "align_left" }
const _hoisted_12 = { class: "align_left" }
const _hoisted_13 = { class: "align_right" }
const _hoisted_14 = { class: "align_right" }
const _hoisted_15 = { class: "pagination" }
const _hoisted_16 = ["onClick"]

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import announceAPI from "../api/announceAPI";
import { Announces } from "../common/types";
import { numberFormat } from "../utils/utils";
import ContractPop from "@/components/popup/ContractPop.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AnnounceView',
  setup(__props) {

const contractFlag = ref(false);

const router = useRouter();
const announcements = ref<Announces[]>([]); // 전체 데이터를 저장
const tabIdx = ref(true); // 탭 인덱스
const currentPage = ref(1); // 현재 페이지 번호
const pageSize = ref(7); // 한 페이지당 보여줄 데이터 개수

const contractClose = () => {
  contractFlag.value = false;
};
// 현재 페이지에 맞는 데이터 계산
const paginatedAnnouncements = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return announcements.value.slice(start, end);
});

// 총 페이지 수 계산
const totalPages = computed(() => Math.ceil(announcements.value.length / pageSize.value));

// 페이지 버튼 계산
const pages = computed(() => {
  const maxPagesToShow = 5; // 보여줄 최대 페이지 버튼 수
  const half = Math.floor(maxPagesToShow / 2);
  let start = Math.max(1, currentPage.value - half);
  let end = Math.min(totalPages.value, currentPage.value + half);

  if (currentPage.value <= half) {
    end = Math.min(totalPages.value, maxPagesToShow);
  } else if (currentPage.value + half >= totalPages.value) {
    start = Math.max(1, totalPages.value - maxPagesToShow + 1);
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
});

// 초기 데이터 로드
onMounted(() => {
  getAnnounceList();
});

// 공고 데이터 가져오기
const getAnnounceList = () => {
  announceAPI.announceList({진행여부:tabIdx.value}).then((res) => {
    announcements.value = res.data.data; // API에서 전체 데이터를 가져옴
  });
};

// 검색 초기화
const initSearch = (idx: boolean) => {
  tabIdx.value = idx;
  currentPage.value = 1;
  getAnnounceList();
};
const clickData = ref()
const seq = ref()
// 상세 페이지 이동
const goDetail = (data: Announces) => {
  if(!data.계약서) {
    alert("등록된 계약서가 없습니다.");
    router.push({ name: `announceDetail`, params: { seq: data.공고순번 } });
  }
  if(data.계약서[`${data.수주수행구분}계약서작성여부`]) {
    router.push({ name: `announceDetail`, params: { seq: data.공고순번 } });
  } else {
    alert("계약서 작성이 완료되지 않았습니다.");
    clickData.value = data
    seq.value = data.계약서.저장파일.저장순번
    contractFlag.value = true
  }
};

// 다음 페이지로 이동
const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

// 이전 페이지로 이동
const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

// 특정 페이지로 이동
const goToPage = (page: number) => {
  currentPage.value = page;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass({ active: tabIdx.value }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (initSearch(true)))
          }, "진행중인 공고", 2),
          _createElementVNode("div", {
            class: _normalizeClass({ active: !tabIdx.value }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (initSearch(false)))
          }, "종료된 공고", 2)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("div", _hoisted_5, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "page_header_circle" }, null, -1),
            _createTextVNode(" 진행중인 공고 ")
          ]), 512), [
            [_vShow, tabIdx.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "page_header_circle" }, null, -1),
            _createTextVNode(" 종료된 공고 ")
          ]), 512), [
            [_vShow, !tabIdx.value]
          ]),
          _createElementVNode("table", _hoisted_7, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "연번"),
                _createElementVNode("th", null, "공고기관"),
                _createElementVNode("th", null, "공고번호"),
                _createElementVNode("th", null, "공고명"),
                _createElementVNode("th", null, "수행구분"),
                _createElementVNode("th", null, "낙찰금액"),
                _createElementVNode("th", null, "수행금액"),
                _createElementVNode("th", null, "수행상태")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedAnnouncements.value, (announcement, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  onClick: ($event: any) => (goDetail(announcement))
                }, [
                  _createElementVNode("td", null, _toDisplayString(announcement.공고순번), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(announcement.공고기관), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(announcement.공고번호), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(announcement.공고명), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(announcement.수주수행구분), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(numberFormat)(announcement.낙찰금액)) + "원", 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(numberFormat)(announcement.수행금액)) + "원", 1),
                  _createElementVNode("td", null, _toDisplayString(announcement.수행상태), 1)
                ], 8, _hoisted_8))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              class: "pagination_left_arrow",
              onClick: prevPage,
              src: _imports_0
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (page) => {
              return (_openBlock(), _createElementBlock("button", {
                key: page,
                onClick: ($event: any) => (goToPage(page)),
                class: _normalizeClass({ active: page === currentPage.value })
              }, _toDisplayString(page), 11, _hoisted_16))
            }), 128)),
            _createElementVNode("img", {
              class: "pagination_right_arrow",
              onClick: nextPage,
              src: _imports_1
            })
          ])
        ])
      ])
    ]),
    (contractFlag.value)
      ? (_openBlock(), _createBlock(ContractPop, {
          key: 0,
          data: clickData.value.계약서,
          onClose: contractClose,
          seq: clickData.value.공고순번,
          seq2: seq.value,
          type: 'U'
        }, null, 8, ["data", "seq", "seq2"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})